import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioEntidadService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getEntidadEmpresarial(codigoBaseDatos: string, uncoSede: number) {
    try {
      const response = await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad-sp',
        [codigoBaseDatos, { unco_sede: uncoSede }]
      );
      return response;
    } catch (e) {
      console.error('ServicioEntidadService.getEntidadEmpresarial()', e);
    }
    return null;
  }
}

export interface EntidadEmpresarialEntity {
  unco ?: number;
  identificacionTributaria ?: string;
  digitoVerificacion ?: string;
  descripcion ?: string;
  direccion ?: string;
  telefono ?: string;
  urlLogo ?: string;
  codigoPrestador ?: string;
  sede ?: string;
  municipio ?: string;
  departamento ?: string;
}
